import React from 'react';

import { Platform, StyleSheet } from 'react-native';
import { withTypography } from 'ucl/components/text/Typography';

import { Box, BoxProps } from 'components/ui';

export const PriceAndCaloriesWrapper = ({ style, ...props }: BoxProps) => (
  <Box
    {...props}
    style={[styles.priceAndCaloriesWrapper, Platform.OS === 'web' && styles.webCentered, style]}
  />
);

export const PriceCaloriesText = withTypography({ fontSize: 'lg' });

const styles = StyleSheet.create({
  priceAndCaloriesWrapper: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: 8,
    marginBottom: 12,
    marginTop: 0,
    width: '100%',
  },
  webCentered: {
    justifyContent: 'center',
  },
});
